import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import scaLanding1 from '../../assets/Images/LandingPage/scaBanner1.webp';
import scaLanding2 from '../../assets/Images/LandingPage/scaBanner2.webp';
import scaLanding3 from '../../assets/Images/LandingPage/scaBanner3.webp';
import scaLanding4 from '../../assets/Images/LandingPage/scaBanner4.webp';
import scaLanding5 from '../../assets/Images/LandingPage/scaBanner5.webp';
import scaLanding6 from '../../assets/Images/LandingPage/scaBanner6.webp';
import scaLanding7 from '../../assets/Images/LandingPage/scaBanner7.webp';
import scaLanding8 from '../../assets/Images/LandingPage/scaBanner8.webp';

const LandingPageCarousel = () => {
  return (
    <Carousel autoPlay infiniteLoop showThumbs={false} showStatus={false}>
      <div>
        <img src={scaLanding1} alt='SCA Banner 1' />
      </div>
      <div>
        <img src={scaLanding2} alt='SCA Banner 2' />
      </div>
      <div>
        <img src={scaLanding3} alt='Banner 3' />
      </div>
      <div>
        <img src={scaLanding4} alt='Banner 4' />
      </div>
      <div>
        <img src={scaLanding5} alt='Banner 5' />
      </div>
      <div>
        <img src={scaLanding6} alt='Banner 6' />
      </div>
      <div>
        <img src={scaLanding7} alt='Banner 7' />
      </div>
      <div>
        <img src={scaLanding8} alt='Banner 8' />
      </div>
    </Carousel>
  );
}

export default LandingPageCarousel;
